import { GroundPoint } from './GroundPoint';
import * as SET from 'cd-eft/_codegen_/openapi-generator/eft-set';

export class XyzSurvey {
  readonly eft_type: string = 'XyzSurvey';
  uuid: string = '';
  surveyId: string = '';
  name: string = '';
  wkid: number = 0;
  groundPoints: GroundPoint[] = [];

  constructor() {}

  static fromDto(dto: SET.SurveyPoints): XyzSurvey {
    if (dto.surveyTypeId !== 1) {
      throw new Error('Invalid argument. This dto is not XyzSurvey');
    }
    const result = new XyzSurvey();
    if (dto.sessionId) result.uuid = dto.sessionId;
    if (dto.surveyId) result.surveyId = dto.surveyId;
    if (dto.surveyName) result.name = dto.surveyName;
    if (dto.surveyCoordinateSystem) result.wkid = dto.surveyCoordinateSystem;
    if (dto.xyzArray && dto.xyzArray.length > 0) {
      for (const xyzDto of dto.xyzArray) {
        const groundPoint = GroundPoint.fromDto(xyzDto, result.wkid);
        result.groundPoints.push(groundPoint);
      }
    }

    return result;
  }
}
